import React, { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Rating,
} from "@mui/material";

export default function FeedBackWithCheckbox() {
  const [feedback, setFeedback] = useState({
    driverPoliteness: false,
    driverRouteFlexibility: false,
    driverBehavior: false,
    driverSafety: false,
    driverFairCharges: false,
    vehicleCondition: false,
    vehicleReliability: false,
    vehicleSafety: false,
    appEaseOfUse: false,
    appAccuracy: false,
    appUpdates: false,
    overallRating: 0,
    additionalComments: "",
  });

  const handleCheckboxChange = (key) => {
    setFeedback((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleRatingChange = (_, value) => {
    setFeedback((prev) => ({ ...prev, overallRating: value }));
  };

  const handleCommentChange = (event) => {
    setFeedback((prev) => ({
      ...prev,
      additionalComments: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch("https://your-backend-api.com/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(feedback),
      });
      if (response.ok) {
        alert("Feedback submitted successfully!");
      } else {
        alert("Failed to submit feedback.");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <Card className="w-full max-w-3xl p-6 shadow-lg rounded-xl">
        <CardContent>
          <Typography variant="h4" className="text-center mb-4 font-bold">
            Rate Your Trip
          </Typography>

          {/* DRIVER FEEDBACK */}
          <Typography variant="h5" className="mt-4 font-semibold">
            Driver Feedback
          </Typography>
          {[
            "Rude",
            "Refused short cut",
            "Misbehaved.",
            "Unsafe driving/not following traffic rules",
            "Demanded tip",
          ].map((key) => (
            <div className="flex flex-col">
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={feedback[key]}
                    onChange={() => handleCheckboxChange(key)}
                  />
                }
                label={key.replace(/([A-Z])/g, " $1").trim()}
              />
            </div>
          ))}

          {/* VEHICLE FEEDBACK */}
          <Typography variant="h5" className="mt-6 font-semibold">
            Vehicle Feedback
          </Typography>
          {[
            "Not well maintained",
            "Broke down during trip",
            "Met with Accident",
          ].map((key) => (
            <div className="flex flex-col">
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={feedback[key]}
                    onChange={() => handleCheckboxChange(key)}
                  />
                }
                label={key.replace(/([A-Z])/g, " $1").trim()}
              />
            </div>
          ))}

          {/* APPLICATION FEEDBACK */}
          <Typography variant="h5" className="mt-6 font-semibold">
            Application Feedback
          </Typography>
          {[
            "Difficult to use",
            "Inaccurate or unreliable",
            "Update doesn’t work",
          ].map((key) => (
            <div className="flex flex-col">
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={feedback[key]}
                    onChange={() => handleCheckboxChange(key)}
                  />
                }
                label={key.replace(/([A-Z])/g, " $1").trim()}
              />
            </div>
          ))}

          {/* OVERALL RATING */}
          <Typography variant="h5" className="mt-6 font-semibold">
            Overall Rating
          </Typography>
          <Rating
            name="overallRating"
            value={feedback.overallRating}
            onChange={handleRatingChange}
            precision={0.5}
            size="large"
          />

          <Typography variant="h5" className="mt-10 font-semibold">
            Additional Comments
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Write any additional comments here..."
            variant="outlined"
            value={feedback.additionalComments}
            onChange={handleCommentChange}
            className="mt-2"
          />
          {/* SUBMIT BUTTON */}
          <div className="flex justify-center mt-6">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              className="px-6 py-2 rounded-lg"
            >
              Submit Feedback
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
